import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.updateUser.loading;
export const todaySchedulesErrorMessage = (state: RootState) =>
  state.todaySchedules.error;
export const todaySchedulesResponse = (state: RootState) =>
  state.todaySchedules.todaySchedulesResponse;
